<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    :width="width"
    top="30px"
    :close-on-click-modal="false"
  >
    <el-form
      @submit.native.prevent
      :model="form"
      :rules="rules"
      status-icon
      ref="form"
      label-position="right"
      :label-width="labelWidth"
    >
      <slot :form="form"></slot>
    </el-form>
    <span slot="footer">
      <el-button type="canale" @click="visible = false">关闭</el-button>
      <el-button type="primary" @click="save" :loading="loading"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: function () {
        return {};
      },
    },
    title: {
      type: String,
      default: "信息",
    },
    width: {
      type: String,
      default: "40%",
    },
    labelWidth: {
      type: String,
      default: "80px",
    },
    getUrl: {
      type: String,
    },
    addUrl: {
      type: String,
    },
    editUrl: {
      type: String,
    },
    rules: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      type: "add", //add edit
      visible: false,
      loading: false,
      form: {},
    };
  },
  provide() {
    return {
      addedit: this,
    };
  },
  watch: {
    item(v) {
      if (this.type == "edit") {
        this.$get(this.getUrl, {
          ...v,
        }).then((r) => {
          this.init({ ...r.Result });
          this.visible = true;
        });
      }
      if (this.type == "add") {
        this.init({ ...v });
        this.visible = true;
      }
    },
  },
  mounted() {},
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        let values = { ...this.form };
        this.loading = true;
        if (this.type == "add") {
          this.$post(this.addUrl, values)
            .then((r) => {
              this.$message.success("添加成功");
              this.visible = false;
              this.$emit("success", r.Result);
            })
            .finally(() => {
              this.loading = false;
            });
        }
        if (this.type == "edit") {
          this.$put(this.editUrl, values)
            .then((r) => {
              this.$message.success("修改成功");
              this.visible = false;
              this.$emit("success", r.Result);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style>
</style>